
{
  "nav.startHere": "ابدأ هنا",
  "nav.about": "حول",
  "nav.protocols": "البروتوكولات",
  "nav.tools": "الأدوات",
  "nav.compliance": "الامتثال",
  "nav.personal": "البروتوكول الشخصي",
  "nav.organization": "بروتوكول المنظمة",
  "nav.mission": "المهمة والرؤية",
  "nav.scope": "النطاق وعدم الضمان",
  "nav.standards": "تخطيط المعايير",
  "nav.changelog": "سجل التغييرات",
  "nav.governance": "الحوكمة",
  "nav.disclaimer": "إخلاء المسؤولية القانونية",
  "nav.contact": "اتصل بنا",
  
  "hero.title1": "أمّن",
  "hero.title2": "عالمك الرقمي",
  "hero.subtitle": "منصة عالمية لبروتوكول الأمن السيبراني والجاهزية للأفراد والمنظمات. بناءً على ممارسات معيارية صناعية وأطر أمنية عالمية.",
  "hero.cta.start": "ابدأ تقييم الأمان",
  "hero.cta.learn": "اعرف المزيد",
  "hero.trust.standards": "متوافق مع المعايير",
  "hero.trust.standardsDesc": "أفضل الممارسات العالمية",
  "hero.trust.defensive": "دفاعي فقط",
  "hero.trust.defensiveDesc": "إرشادات أمنية أخلاقية",
  "hero.trust.global": "منصة عالمية",
  "hero.trust.globalDesc": "بروتوكولات دولية",
  
  "home.tab.personal": "البروتوكول الشخصي",
  "home.tab.organization": "بروتوكول المنظمة",
  "home.personal.title": "ابدأ بهذه الخطوات العشر",
  "home.personal.desc": "ضوابط أمنية أساسية يجب على كل فرد تنفيذها فوراً لمنع 90٪ من الهجمات الشائعة.",
  "home.org.title": "خط الأساس الأمني للمنظمة",
  "home.org.desc": "ضوابط الحوكمة والتقنية الأساسية التي يجب على كل منظمة إنشاؤها لتقليل المخاطر السيبرانية وتحسين المرونة.",
  "home.org.note": "تمثل هذه الخطوات خط أساس أدنى يمكن للمنظمات تنفيذه فوراً، بغض النظر عن الحجم أو الصناعة.",
  "home.principle1.title": "الدفاع المتعمق",
  "home.principle1.titleOrg": "الأمن متعدد الطبقات",
  "home.principle1.desc": "تطبيق ضوابط أمنية متعددة ومستقلة بحيث لا يؤدي فشل ضابط واحد إلى تعريض الأمان الكلي للخطر.",
  "home.principle1.descOrg": "ضوابط مستقلة متعددة بحيث إذا فشل أحدها، تظل الأخرى فعالة.",
  "home.principle2.title": "عقلية الثقة المعدومة",
  "home.principle2.titleOrg": "التحقق المستمر",
  "home.principle2.desc": "لا تعتمد على الثقة الضمنية. تحقق باستمرار من الوصول بناءً على الهوية والجهاز والسياق.",
  "home.principle2.descOrg": "تحقق من كل طلب وصول وافترض احتمال الاختراق في جميع الأوقات.",
  "home.standards.badge": "نهج قائم على المعايير",
  "home.standards.title": "مبني على معايير الأمان العالمية",
  "home.standards.desc": "بروتوكولاتنا متوافقة بدقة مع أطر الأمن السيبراني وأفضل الممارسات المعترف بها دولياً.",
  "home.standards.risk.title": "إدارة المخاطر",
  "home.standards.risk.desc": "نهج شامل قائم على المخاطر لحوكمة الأمن السيبراني والمرونة التشغيلية.",
  "home.standards.risk.functions": "الحوكمة، التحديد، الحماية، الكشف، الاستجابة، الاسترداد",
  "home.standards.controls.title": "ضوابط الأمان",
  "home.standards.controls.desc": "معيار دولي لأنظمة إدارة أمن المعلومات مع ضوابط شاملة.",
  "home.standards.controls.count": "114 ضابط أمني عبر 14 مجالاً",
  "home.standards.practices.title": "أفضل الممارسات",
  "home.standards.practices.desc": "ضوابط أمنية ذات أولوية وقابلة للتنفيذ للدفاع ضد الهجمات السيبرانية الأكثر شيوعاً.",
  "home.standards.practices.count": "18 ضابط أمني حرج",
  "home.standards.cta": "عرض تخطيط المعايير الكامل",
  
  "footer.brand.desc": "منصة عالمية لبروتوكول الأمن السيبراني والجاهزية للأفراد والمنظمات.",
  "footer.brand.note": "إرشادات أمنية دفاعية متوافقة مع المعايير.",
  "footer.protocols": "البروتوكولات",
  "footer.resources": "الموارد",
  "footer.about": "حول",
  "footer.riskAssessment": "تقييم المخاطر",
  "footer.toolsLibrary": "مكتبة الأدوات",
  "footer.complianceGuides": "أدلة الامتثال",
  "footer.standardsMapping": "تخطيط المعايير",
  "footer.missionVision": "المهمة والرؤية",
  "footer.scopeDisclaimer": "النطاق وإخلاء المسؤولية",
  "footer.contact": "اتصل",
  "footer.copyright": "CyberSecurityProtocol. جميع الحقوق محفوظة.",
  "footer.educational": "إرشادات أمن سيبراني تعليمية ودفاعية فقط.",
  "footer.legal": "قانوني",
  "footer.nonGuarantee": "عدم الضمان",
  "footer.builtBy": "بناه UXER — جزء من جمعية تكنولوجيا المعلومات والمصادر المفتوحة (ATIOS)",
  
  "common.loading": "جاري التحميل...",
  "common.error": "خطأ",
  "common.success": "نجاح",
  "common.cancel": "إلغاء",
  "common.save": "حفظ",
  "common.continue": "متابعة",
  "common.back": "رجوع",
  "common.next": "التالي",
  "common.finish": "إنهاء",
  "common.viewMore": "عرض المزيد",
  "common.learnMore": "اعرف المزيد",
  "common.getStarted": "ابدأ"
}
